var React = require('react');

function TextWatermarkTwo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"SVGID_2","className":"st0","d":"M0,677.3c0,0,172.2-33.9,196.4-41.3c67.8-20.7,167.9-68.2,154-201.7\n\tC330.4,242,345.9,136.1,474.1,78S781,85.8,781,85.8","key":0}),React.createElement("text",{"key":1},React.createElement("textPath",{"xlinkHref":"#SVGID_2","startOffset":"0%"},[React.createElement("tspan",{"style":{"fontFamily":"'proxima-nova', sans-serif","fontWeight":"600","fontSize":"26px","textTransform":"uppercase","letterSpacing":"0.5rem"},"key":0},"beauty parlor & barber "),React.createElement("tspan",{"style":{"fontFamily":"'Grouch ITC'","fontSize":"64px","letterSpacing":"0"},"key":1},"collective haus")]))]);
}

TextWatermarkTwo.defaultProps = {"version":"1.1","fill":"currentColor","id":"Layer_1","viewBox":"0 0 781 677.3"};

module.exports = TextWatermarkTwo;

TextWatermarkTwo.default = TextWatermarkTwo;
